// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"d576c58f553c09094242","454":"db35bbf366e9a2cdb471"}[chunkId] + ".js";
};